import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { Link } from 'react-router-dom';
import { VERSION_MANAGER_OPTIONS } from './utils';
import { Status, defaultDeviceTypesSelection } from 'common/utils/constants';
import {
  deleteSoftwareVersion,
  setPage,
  updateStatus,
  getDefaultSwList,
  doGetAllBeamTables,
  doGetProductTypesList,
  doDeleteBeamTable,
  uploadSoftware,
  uploadBeamTable
} from 'redux/actions';
import ConsoleTile from 'components/shared/ConsoleTile/ConsoleTile';
import { SoftwareUploadModal } from 'components/features/SoftwareUploadModal/SoftwareUploadModal';
import { SoftwareManagerTable } from 'components/features/SoftwareManagerTable/SoftwareManagerTable';
import { AddSoftwareVersionModal } from 'components/features/AddSoftwareVersionModal/AddSoftwareVersionModal';
import IbmsVersionModal from 'components/features/IbmsVersionDialog/IbmsVersionModal';
import { DefaultSWVersionTable } from 'components/features/DefaultSWVersionTable/DefaultSWVersionTable';
import { BeamTablesManagerTable } from 'components/features/BeamTablesManagerTable/BeamTablesManagerTable';
import DeleteVersionModal from './components/DeleteVersionModal/DeleteVersionModal';
import VersionManagerTileHeader from './components/VersionManagerTileHeader/VersionManagerTileHeader';
import './AdminPage.css';

// update this when creating a release branch
const IBMS_UNIFIED_VERSION = '25.29.01';

const UNIFIED_VERSION_VIEW_ONLY_PERM = 'gui_unified_version_view_only';
const VIEW_VERSION_DETAILS_PERM = 'gui_view_version_details';

class AdminPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploadFile: null,
      swVersionTableData: [],
      allBeamTablesData: [],
      defaultSwTableData: [],
      uploadModalOpen: false,
      addNewVersionModalOpen: false,
      deleteSwModalOpen: false,
      deleteBeamTableModalOpen: false,
      ibmsVersionModalOpen: false,
      uploadProgress: 0,
      deleteSwFailed: false,
      deleteSwPending: false,
      uploadSWPermissions: false,
      deleteSWPermissions: false,
      authAssignPermissions: false,
      authDeletePermissions: false,
      authReadPermissions: false,
      cmSWUpdatePermissions: false,
      swDefaultSwVersionReadPermission: false,
      swDefaultSwVersionWritePermission: false,
      deviceTypes: defaultDeviceTypesSelection,
      hasSwUpdateRecurrence: false,
      versionManagerSelection: VERSION_MANAGER_OPTIONS.SOFTWARE
    };

    this.updateDefaultSwTableData = this.updateDefaultSwTableData.bind(this);
    this.updateSwTableData = this.updateSwTableData.bind(this);
    this.updateAllBeamTablesData = this.updateAllBeamTablesData.bind(this);
    this.getSwVersion = this.getSwVersion.bind(this);

    this.fileInputRef = React.createRef();
  }

  hasUnifiedVersionViewDetailsPerm = () => this.props.permissions.includes(VIEW_VERSION_DETAILS_PERM);

  hasUnifiedVersionViewOnlyPerm = () => this.props.permissions.includes(UNIFIED_VERSION_VIEW_ONLY_PERM);

  getUnifiedVersionConsole = () => {
    if (this.hasUnifiedVersionViewDetailsPerm()) {
      return (
        <div className="AdminPage_IbmsVersionContainer">
          <button onClick={() => this.setState({ ibmsVersionModalOpen: true })} className="IbmsVersionButton">
            {`IBMS Version ${IBMS_UNIFIED_VERSION}`}
          </button>
        </div>
      );
    }

    if (this.hasUnifiedVersionViewOnlyPerm()) {
      return (
        <div className="AdminPage_IbmsVersionContainer">
          <button className="IbmsVersionButton_Disabled">{`IBMS Version ${IBMS_UNIFIED_VERSION}`}</button>
        </div>
      );
    }

    return null;
  };

  updateAllBeamTablesData() {
    let data = [];
    if (this.props.allBeamTables != null && this.props.allBeamTables['value'] != null) {
      this.props.allBeamTables['value'].forEach((beamTable) => {
        data.push(beamTable);
      });
    }
    if (JSON.stringify(this.state.allBeamTablesData) !== JSON.stringify(data)) {
      this.setState({ allBeamTablesData: data });
    }
  }

  updateDefaultSwTableData() {
    let data = [];
    if (this.props.defaultsList != null && this.props.defaultsList['value'] != null) {
      this.props.defaultsList['value'].forEach((sw) => {
        data.push(sw);
      });
    }
    if (JSON.stringify(this.state.defaultSwTableData) !== JSON.stringify(data)) {
      this.setState({ defaultSwTableData: data });
    }
  }

  updateSwTableData() {
    let data = [];
    if (this.props.swVersions != null && this.props.swVersions['all'] != null) {
      this.props.swVersions['all'].forEach((sw) => {
        data.push(sw);
      });
    }
    if (JSON.stringify(this.state.swVersionTableData) !== JSON.stringify(data)) {
      this.setState({ swVersionTableData: data });
    }
  }

  componentDidMount() {
    const {
      props: { permissions, dispatch }
    } = this;

    dispatch(setPage('AdminPage'));
    this.updateSwTableData();
    this.updateDefaultSwTableData();
    this.updateAllBeamTablesData();
    this.props.dispatch(getDefaultSwList());
    this.props.dispatch(doGetAllBeamTables());
    if (!this.props.productTypesList) dispatch(doGetProductTypesList());

    if (permissions) {
      if (permissions.includes('sw_upload')) this.setState({ uploadSWPermissions: true });

      if (permissions.includes('sw_delete')) this.setState({ deleteSWPermissions: true });

      if (permissions.includes('auth_assign')) this.setState({ authAssignPermissions: true });

      if (permissions.includes('auth_delete')) this.setState({ authDeletePermissions: true });

      if (permissions.includes('auth_read')) this.setState({ authReadPermissions: true });

      if (permissions.includes('cm_software_update')) this.setState({ cmSWUpdatePermissions: true });

      if (permissions.includes('sw_default_swversion_read')) this.setState({ swDefaultSwVersionReadPermission: true });

      if (permissions.includes('sw_default_swversion_write'))
        this.setState({ swDefaultSwVersionWritePermission: true });
    }
  }

  componentDidUpdate() {
    this.updateSwTableData();
    this.updateDefaultSwTableData();
    this.updateAllBeamTablesData();
    ReactTooltip.rebuild();
  }

  getSwIdentifier(str) {
    let keys = Object.keys(this.props.swVersions);
    for (let i = 0; i < keys.length; i++) {
      for (let j = 0; j < this.props.swVersions[keys[i]].length; j++) {
        if (this.props.swVersions[keys[i]][j].sw_version === str) {
          return this.props.swVersions[keys[i]][j].sw_identifier;
        }
      }
    }
    return null;
  }

  getSwVersion(str) {
    let keys = Object.keys(this.props.swVersions);
    for (let i = 0; i < keys.length; i++) {
      for (let j = 0; j < this.props.swVersions[keys[i]].length; j++) {
        if (this.props.swVersions[keys[i]][j].sw_identifier === str) {
          return this.props.swVersions[keys[i]][j].sw_version;
        }
      }
    }
    return null;
  }

  handleAddNewSwVersion = () => {
    const deviceTypesArray = [];

    this.state.deviceTypes.forEach((obj) => {
      if (obj.selected) {
        deviceTypesArray.push(obj.name);
      }
    });

    this.setState({ uploadModalOpen: true, addNewVersionModalOpen: false });
    this.props.dispatch(
      uploadSoftware(
        this.state.uploadFile,
        (evt) => {
          let progress = (evt.loaded / evt.total) * 100;
          console.log('evt:', evt);
          console.log('progress:', progress);
          if (progress < 100) {
            this.setState({ uploadProgress: progress });
          } else {
            this.setState({ uploadProgress: 100 });
          }
        },
        deviceTypesArray
      )
    );
    this.resetAddNewVersionModal();
  };

  handleAddNewBeamTable = () => {
    this.setState({ uploadModalOpen: true, addNewVersionModalOpen: false });
    this.props.dispatch(
      uploadBeamTable(this.state.uploadFile, (evt) => {
        let progress = (evt.loaded / evt.total) * 100;
        console.log('evt:', evt);
        console.log('progress:', progress);
        if (progress < 100) {
          this.setState({ uploadProgress: progress });
        } else {
          this.setState({ uploadProgress: 100 });
        }
      })
    );
    this.resetAddNewBeamTableModal();
  };

  resetAddNewVersionModal = () => {
    this.setState({
      uploadFile: null,
      deviceTypes: defaultDeviceTypesSelection
    });
  };

  resetAddNewBeamTableModal = () => {
    this.setState({
      uploadFile: null
    });
  };

  handleAddNewVersionOnClick = () => {
    if (this.state.versionManagerSelection === VERSION_MANAGER_OPTIONS.SOFTWARE) {
      return this.handleAddNewSwVersion;
    }

    if (this.state.versionManagerSelection === VERSION_MANAGER_OPTIONS.BEAM_TABLES) {
      return this.handleAddNewBeamTable;
    }
  };

  handleDeviceTypeOnClick = (index) => {
    let newDeviceTypes = JSON.parse(JSON.stringify(this.state.deviceTypes));
    newDeviceTypes[index].selected = !newDeviceTypes[index].selected;
    this.setState({ deviceTypes: newDeviceTypes });
  };

  validateScheduleText = () => {
    const scheduleText = this.props.autoUpdateSchedule?.scheduleText || '';
    return scheduleText.includes('Unknown') || scheduleText.includes('undefined') || scheduleText.includes('NaN');
  };

  closeSwModal = () => {
    this.setState({
      deleteSwModalOpen: false,
      deleteSwPending: false,
      deleteSwFailed: false,
      addNewVersionModalOpen: false,
      uploadFile: null
    });

    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
  };

  closeBeamTableModal = () => {
    this.setState({
      deleteBeamTableModalOpen: false,
      deleteBeamTablePending: false,
      deleteBeamTableFailed: false,
      addNewVersionModalOpen: false,
      uploadFile: null
    });

    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = '';
    }
  };

  render() {
    const {
      props: {
        dispatch,
        swVersionsFetching,
        swVersionsError,
        allBeamTablesFetching,
        allBeamTablesError,
        defaultSwVersionFetching,
        filteredUsers,
        roleUsers,
        swVersionUploadError,
        swVersionUploadSuccess,
        beamTableUploadError,
        beamTableUploadSuccess
      },
      state: {
        uploadFile,
        deviceTypes,
        deleteSwFailed,
        deleteSwVersionId,
        deleteSwPending,
        deleteBeamTableFailed,
        deleteBeamTableId,
        deleteBeamTableVersion,
        deleteBeamTablePending,
        swVersionTableData,
        defaultSwTableData,
        allBeamTablesData,
        uploadModalOpen,
        uploadProgress,
        deleteSwModalOpen,
        deleteBeamTableModalOpen,
        addNewVersionModalOpen,
        ibmsVersionModalOpen,
        versionManagerSelection,
        authAssignPermissions,
        authDeletePermissions,
        authReadPermissions,
        swDefaultSwVersionReadPermission,
        swDefaultSwVersionWritePermission
      }
    } = this;

    const deviceTypesArray = [];

    deviceTypes.forEach((obj) => {
      if (obj.selected) {
        deviceTypesArray.push(obj.name);
      }
    });

    const versionManagerTileHeader = (
      <VersionManagerTileHeader
        selected={versionManagerSelection}
        handleSelectionOnClick={(selection) => {
          this.setState({ versionManagerSelection: selection });
        }}
        fileInputRef={this.fileInputRef}
        handleFileUploadOnChange={(evt) => {
          this.setState({ uploadFile: evt.target.files[0] });
        }}
        handleFileUploadOnClick={() => {
          this.setState({ addNewVersionModalOpen: true });
        }}
        uploadSWPermissions={this.state.uploadSWPermissions}
      />
    );

    const setDefaultSWTileHeader = (
      <div className="AdminPage_setDefaultSWTileHeader_OuterDiv">
        <div className="AdminPage_setDefaultSWTileHeader_Title">Set default SW version for device type</div>
      </div>
    );

    const acctManagerTileHeader = (
      <div className="AdminPage_acctManagerTileHeader_OuterDiv">
        <div className="AdminPage_acctManagerTileHeader_Title">Accounts</div>
      </div>
    );

    const deleteSwModal = (
      <DeleteVersionModal
        title={`Delete Software Version ${this.getSwVersion(deleteSwVersionId)} ?`}
        failed={deleteSwFailed}
        pending={deleteSwPending}
        onClose={this.closeSwModal}
        onClick={() => {
          this.setState({ deleteSwPending: true });
          dispatch(
            deleteSoftwareVersion(
              deleteSwVersionId,
              () => {
                this.setState({ deleteSwModalOpen: false });
              },
              (error) => {
                this.setState({ deleteSwFailed: true });
              }
            )
          );
        }}
      />
    );

    const deleteBeamTableModal = (
      <DeleteVersionModal
        title={`Delete Beam Table Version ${deleteBeamTableVersion} ?`}
        failed={deleteBeamTableFailed}
        pending={deleteBeamTablePending}
        onClose={this.closeBeamTableModal}
        onClick={() => {
          this.setState({ deleteBeamTablePending: true });
          dispatch(
            doDeleteBeamTable(
              deleteBeamTableId,
              () => {
                this.setState({ deleteBeamTableModalOpen: false });
              },
              (error) => {
                this.setState({ deleteBeamTableFailed: true });
              }
            )
          );
        }}
      />
    );

    return (
      <div className="AdminPage pageStyle">
        <div className="AdminPage_Title">
          <span>Admin</span>
        </div>
        <div className="AdminPage_TileDivContainer">
          <div className="AdminPage_SwManagerTileDiv">
            <ConsoleTile tileHeader={versionManagerTileHeader}>
              <div className="AdminPage_swManager_TableDiv">
                {versionManagerSelection === VERSION_MANAGER_OPTIONS.SOFTWARE ? (
                  <SoftwareManagerTable
                    fetching={swVersionsFetching}
                    error={swVersionsError}
                    swVersionTableData={swVersionTableData}
                    parent={this}
                  />
                ) : (
                  <BeamTablesManagerTable
                    fetching={allBeamTablesFetching}
                    error={allBeamTablesError}
                    beamTablesData={allBeamTablesData}
                    parent={this}
                  />
                )}
              </div>
            </ConsoleTile>
          </div>
          <div className="AdminPage_AcctManagerTileDiv">
            {authAssignPermissions && authDeletePermissions && authReadPermissions && (
              <ConsoleTile tileHeader={acctManagerTileHeader}>
                <div className="AdminPage_acctManager_ButtonDiv">
                  <Link
                    to={'/console/admin/users-management'}
                    onClick={() => {
                      if (!filteredUsers.local || !filteredUsers.original) {
                        let getUsersStatusName = 'GET-Users';
                        dispatch(updateStatus(getUsersStatusName, Status.PENDING));
                      }

                      if (!roleUsers) {
                        let getRoleUsersStatusName = 'GET-Role-Users';
                        dispatch(updateStatus(getRoleUsersStatusName, Status.PENDING));
                      }
                    }}
                  >
                    <div className="AdminPage_acctManager_ManageUsersButton">
                      <div className="AdminPage_acctManager_buttonTitle">Users</div>
                      <div className="AdminPage_acctManager_buttonDetails">Manage users and settings</div>
                    </div>
                  </Link>
                  {authReadPermissions && (
                    <Link
                      to={'/console/admin/roles-config'}
                      onClick={() => {
                        if (!filteredUsers.local || !filteredUsers.original) {
                          let getUsersStatusName = 'GET-Users';
                          dispatch(updateStatus(getUsersStatusName, Status.PENDING));
                        }

                        if (!roleUsers) {
                          let getRoleUsersStatusName = 'GET-Role-Users';
                          dispatch(updateStatus(getRoleUsersStatusName, Status.PENDING));
                        }
                      }}
                    >
                      <div className="AdminPage_acctManager_ManageRolesButton">
                        <div className="AdminPage_acctManager_buttonTitle">Roles</div>
                        <div className="AdminPage_acctManager_buttonDetails">
                          Manage existing roles or create new roles
                        </div>
                      </div>
                    </Link>
                  )}
                </div>
              </ConsoleTile>
            )}
            {swDefaultSwVersionReadPermission && (
              <ConsoleTile tileHeader={setDefaultSWTileHeader}>
                <div className="AdminPage_swManager_TableDiv">
                  <DefaultSWVersionTable
                    fetching={defaultSwVersionFetching}
                    data={defaultSwTableData}
                    parent={this}
                    defaults={this.props.defaultsList}
                    swDefaultSwVersionWritePermission={swDefaultSwVersionWritePermission}
                    productTypesList={this.props.productTypesList}
                  />
                </div>
              </ConsoleTile>
            )}
            {this.getUnifiedVersionConsole()}
          </div>
        </div>

        {uploadModalOpen ? (
          <SoftwareUploadModal
            selectionMode={versionManagerSelection}
            closing={!uploadModalOpen}
            close={() => this.setState({ uploadModalOpen: false })}
            progress={uploadProgress}
            error={versionManagerSelection === VERSION_MANAGER_OPTIONS.SOFTWARE ? swVersionUploadError : beamTableUploadError}
            success={
              versionManagerSelection === VERSION_MANAGER_OPTIONS.SOFTWARE ? swVersionUploadSuccess : beamTableUploadSuccess
            }
          />
        ) : null}
        {deleteSwModalOpen ? deleteSwModal : null}
        {deleteBeamTableModalOpen ? deleteBeamTableModal : null}
        {addNewVersionModalOpen && (
          <AddSoftwareVersionModal
            title={
              versionManagerSelection === VERSION_MANAGER_OPTIONS.SOFTWARE
                ? 'Upload new software version'
                : 'Upload new beam table'
            }
            selectionMode={versionManagerSelection}
            uploadFile={uploadFile}
            fileInputRef={this.fileInputRef}
            deviceTypes={deviceTypes}
            handleOnCloseModal={this.closeSwModal}
            handleOnClick={this.handleAddNewVersionOnClick()}
            handleDeviceTypeOnClick={this.handleDeviceTypeOnClick}
          />
        )}
        {ibmsVersionModalOpen && (
          <IbmsVersionModal
            ibmsUnifiedVersion={IBMS_UNIFIED_VERSION}
            onClose={() => this.setState({ ibmsVersionModalOpen: false })}
          ></IbmsVersionModal>
        )}
      </div>
    );
  }
}

export default connect((store) => {
  return {
    defaultsList: store.data.defaultsList,
    defaultSwVersionFetching:
      store.statuses.GetDefaultSWVersion === Status.PENDING || store.statuses.PatchDefaultSWVersion === Status.PENDING,

    swVersions: store.data.softwareVersions,
    swVersionsFetching: store.statuses.GetSoftwareVersions === Status.PENDING,
    swVersionsError: store.statuses.GetSoftwareVersions === Status.FAILURE,

    allBeamTables: store.data.allBeamTables,
    allBeamTablesFetching: store.statuses.GetAllBeamTables === Status.PENDING,
    allBeamTablesError: store.statuses.GetAllBeamTables === Status.FAILURE,

    swVersionUploadError: store.statuses.SoftwareUpload === Status.FAILURE,
    swVersionUploadSuccess: store.statuses.SoftwareUpload === Status.SUCCESS,

    beamTableUploadError: store.statuses.BeamTableUpload === Status.FAILURE,
    beamTableUploadSuccess: store.statuses.BeamTableUpload === Status.SUCCESS,

    permissions: store.data.rolePermissions.permissions,
    roles: store.data.rolePermissions.roles || [],
    filteredUsers: store.ui.usersManagementPage.filteredUsers,
    roleUsers: store.ui.usersManagementPage.roleUsers,

    productTypesList: store.data.productTypesList
  };
})(AdminPage);
